import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { setBreadcrumb } from '../actions/breadcrumb'
import { updateItemReason, postItem, deleteItem } from '../actions/items'
import { updateMode } from '../actions/shipback'
import { resetQuotes } from '../actions/quotes'
import { isEmpty } from '../assets/utils'

import { SHIPPING, UNKNOWN } from '../assets/constant'

import ReturnItem from './ReturnItem'
import ReturnSize from './ReturnSize'

class ReturnItems extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.state = { flash: "", error: null }
    this.selectItem = this.selectItem.bind(this)
    this.goToSelectMode = this.goToSelectMode.bind(this)
    this.itemReturned = this.itemReturned.bind(this)
  }

  componentWillMount() {
    this.props.resetQuotes()
  }

  selectItem(item, reason_code){
    if (reason_code == "not_returned") {
      this.removeItem(item.returned_item.id)
    } else {
      if (!item.returned && reason_code != undefined && reason_code != "") {
        this.addItem(item.id, reason_code)
      } else {
        if (reason_code != undefined && reason_code != "") {
          for (var i = 0; i < this.props.items.length; i++) {
            var return_item = this.props.items[i]
            if (return_item.id == item.id) {
              if (item.returned) {
                if (reason_code == return_item.returned_item.reason_code) {
                  this.removeItem(item.returned_item.id)
                } else {
                  this.replaceItem(item.returned_item.id, reason_code)
                }
              }
            }
          }
        } else {
          this.setState({ error: "shipbacks.items.update.error", flash: "flash error" })
        }
      }
    }
  }

  removeItem(item_id) {
    this.props.deleteItem(item_id, shipback_id, this.props.user_token)
    this.setState({ error: null, flash: ""})
  }

  addItem(item_id, reason_code) {
    this.props.postItem(item_id, reason_code, shipback_id, this.props.user_token)
    this.setState({ error: null, flash: ""})
  }

  replaceItem(item_id, reason_code) {
    this.props.updateItemReason(item_id, reason_code, shipback_id, this.props.user_token)
    this.setState({ error: null, flash: ""})
  }

  itemReturned() {
    for (var i = 0; i < this.props.items.length; i++) {
      var item = this.props.items[i]
      if (item.returned) {
        return true
      }
    }
    return false
  }

  goToSelectMode() {
    if (this.itemReturned() && this.props.shipback.size != "") {
      this.props.setBreadcrumb(SHIPPING)
    } else {
      this.setState({ error: "shipbacks.items.update.error", flash: "flash error" })
    }
  }

  render() {
    if (!isEmpty(this.props.reasons)) {
    return (
      <div className="row items">
        <div className={this.state.flash}>
          <span>{this.state.error ? I18n.t(this.state.error) : ""}</span>
        </div>
        <div className="col-10 offset-1">
          <h2>{I18n.t('shipbacks.items.items.title')}</h2>
          <div className="row headlines hidden-sm-down">
            <div className="col-9">
             <span>{I18n.t('shipbacks.items.items.product')}</span>
            </div>
            <div className="col-3">
              <span>{I18n.t('shipbacks.items.items.reason')}</span>
            </div>
          </div>
          <div className="basket">
            {this.props.items.map((item) => (
              <ReturnItem
                item={item}
                key={item.id}
                selectItem={this.selectItem}
                selected={item.returned}
                reason={item.returned ? item.returned_item.reason_code : ""}
                reasons={this.props.reasons} />
            ))}
          </div>
          {
            !isEmpty(this.props.sizes) ?
            <ReturnSize />
            : null
          }
          <a href="#" className="submit pull-right" onClick={this.goToSelectMode}>{I18n.t('shipbacks.items.show.submit')}</a>
        </div>
      </div>
    )
    } else {
      return (
        <div className="row spinner">
          <div className="col-12">
             <i className="fa-li fa fa-3x fa-spinner fa-spin"/>
            <h3>{I18n.t('shipbacks.items.show.loading')}</h3>
          </div>
        </div>
      )
    }
  }
}

const mapStateToProps = state => ({
  reasons: state.company.company.reasons,
  items: state.items.list,
  shipback: state.shipback,
  user_token: state.user,
  sizes: state.sizes,
})

const mapDispatchToProps = dispatch => bindActionCreators({ setBreadcrumb, updateItemReason, postItem, deleteItem, resetQuotes, updateMode }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReturnItems)


// WEBPACK FOOTER //
// ./app/javascript/components/components/ReturnItems.jsx